import React from "react";

// --- Brand icon set (Brand Document, page 9) as inline SVGs ---
export const Icon = ({ name }) => {
  switch (name) {
    case "ai": // AI / metrics arrow
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3a9 9 0 1 0 9 9" />
          <path d="M21 3 12 12" />
          <path d="M15 3h6v6" />
        </svg>
      );
    case "control": // checkmark shield
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="m9 11 2.5 2.5L16 9" />
        </svg>
      );
    case "evidence": // documents
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <path d="M14 2v6h6" />
          <path d="M8 13h8M8 17h8M8 9h2" />
        </svg>
      );
    case "map": // map + magnify
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 3 3 5v16l6-2 6 2 6-2V3l-6 2-6-2z" />
          <path d="M9 3v16M15 5v10" />
        </svg>
      );
    case "risk": // warning triangle
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
          <path d="M12 9v4M12 17h.01" />
        </svg>
      );
    case "dashboard": // bars
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 3v18h18" />
          <path d="M18 17V9M13 17V5M8 17v-3" />
        </svg>
      );
    case "web": // globe
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3c2.5 2.5 3.8 5.7 3.8 9S14.5 18.5 12 21c-2.5-2.5-3.8-5.7-3.8-9S9.5 5.5 12 3z" />
        </svg>
      );
    case "scales": // FAIR / scales
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3v18M7 21h10M5 7h14M12 4l-7 3 3 6a3.5 3.5 0 0 1-6 0M12 4l7 3-3 6a3.5 3.5 0 0 0 6 0" />
        </svg>
      );
    // Values (About) icons reuse this component too
    case "empower":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M13 2 4.5 12.5H11l-1 9L19.5 11H13z" />
        </svg>
      );
    case "collaboration":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="8" cy="9" r="3" />
          <circle cx="16" cy="9" r="3" />
          <path d="M2 20c0-3 2.7-5 6-5s6 2 6 5M14 15c3.3 0 6 2 6 5" />
        </svg>
      );
    case "integrity":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      );
    case "innovation":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 18h6M10 22h4" />
          <path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1h6c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z" />
        </svg>
      );
    case "excellence":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m12 2 3 6.5 7 .8-5.2 4.7 1.5 6.9L12 17.7 5.7 21l1.5-6.9L2 9.3l7-.8z" />
        </svg>
      );
    default:
      return null;
  }
};
